enum TripSchedule {
  SERVICE = 'trip_schedule_service',
  GROUP = 'trip_schedule_group',
}

export { TripSchedule }
